import type { ThemeColors } from '../../themes/ThemeTypes';

const colors: ThemeColors = {
  primary: '#007BFF',
  secondary: '#1C7CE1',
  tertiary: '#0087CE',
  dark: '#353535',
  light: '#A3A3A3',
  extraLight: '#F6F4F2',
  white: '#ffffff',
  black: '#252525',
  grey: '#E2E0DD',
  off: '#606060',
  offWhite: '#E2E0DD',
  primaryHover: '#0087CE',
  error: '#E31651',
  success: '#00C853',
  successDark: '#00A042',
  external: '#0087CE',
  cheap: '#D9F7E5',
  day: '#FAD1DC',
  peak: '#FFF1CC',
  pale: '#FFF1CC',
  solar: '#FFCC47',
  solarLight: '#FFF1CC',
  footer: '#FFCC47',
  footerText: '#252525',
  imported: '#f00050',
  exported: '#007BFF',
  headerText: '#252525',
  altText: '#000000',
  progressBar: '#1C7CE1',
  themedFormHeaders: '#007BFF',

  icons: {
    solarIconBackground: '#FFF000',
    batteryIconBackground: '#E31651',
    gridIconBackground: '#1E87e5',
    gridIconBorder: `2px solid ${'#1E87e5'}`,
    consumptionIconBackground: '#00B0FF',
    inverterIconBackground: '#1C7CE1',
  },

  gradients: {
    primary: 'linear-gradient(260deg, #822a9f, #1459A2 100%)',
    secondary: 'linear-gradient(260deg, #bc1793, #772da1 100%)',
    tertiary: 'linear-gradient(to right, #00487B, #003A62)',
    success: 'linear-gradient(80deg, #00A042, #00A042 100%)',
    danger: 'linear-gradient(260deg, #E31651, #CC1449 100%)',
    warning: 'linear-gradient(260deg, #880055, #880055 100%);',
    info: 'linear-gradient(260deg, #1459A2, #1459A2 100%)',
    app: 'linear-gradient(80deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(245,245,245,1) 50%, rgba(245,245,245,1) 100%)',
    electricity: 'linear-gradient(80deg, #e5098b, #ff594f 100%)',
    heating: 'linear-gradient(80deg, #0259ab, #19d5ff 100%)',
    car: 'linear-gradient(80deg, #629c10, #74b816 100%)',
    solar: 'linear-gradient(80deg, #FFCC47, #FFCC47 100%)',
    solarReverse: 'linear-gradient(-80deg, #FFCC47, #FFCC47 100%)',
    header: 'linear-gradient(0deg, #FFFFFF, #FFFFFF 100%)',
    imported: 'linear-gradient(80deg, #e5098b, #ff594f 100%)',
    exported: 'linear-gradient(260deg, #bc1793, #772da1 100%)',
    alternative: 'linear-gradient(80deg, #FFCC47, #FFCC47 100%)',
  },

  verticalgradients: {
    primary: 'linear-gradient(180deg, #822a9f, #1459A2 100%)',
    secondary: 'linear-gradient(180deg, #bc1793, #772da1 100%)',
    tertiary: 'linear-gradient(180deg, #6433a5, #2747b1 100%)',
    success: 'linear-gradient(0deg, #00A042, #00A042 100%)',
    danger: 'linear-gradient(180deg, #E31651, #CC1449 100%)',
    warning: 'linear-gradient(180deg, #880055, #880055 100%);',
    info: 'linear-gradient(180deg, #1459A2, #1459A2 100%)',
    app: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(245,245,245,1) 50%, rgba(245,245,245,1) 100%)',
    electricity: 'linear-gradient(180deg, #e5098b, #ff594f 100%)',
    heating: 'linear-gradient(180deg, #0259ab, #19d5ff 100%)',
    car: 'linear-gradient(180deg, #629c10, #74b816 100%)',
    solar: 'linear-gradient(180deg, #FFCC47, #FFCC47 100%)',
    header: 'linear-gradient(0deg, #FFFFFF, #FFFFFF 100%)',
    solarReverse: 'linear-gradient(-180deg, #FFCC47, #FFCC47 100%)',
    imported: 'linear-gradient(-180deg, #e5098b, #ff594f 100%)',
    exported: 'linear-gradient(-180deg, #bc1793, #772da1 100%)',
    alternative: 'linear-gradient(80deg, #FFCC47, #FFCC47 100%)',
  },
};

export default colors;
